import { useMutation, UseMutationResult } from "@tanstack/react-query"
import { InAppMessagingThread, NewThread } from "../inAppMessagingTypes"
import ResponseError from "#/types/responseError"
import { carrotClient } from "#/utils/CarrotClient"
import { HttpStatusCodes } from "#/utils/HttpStatusCodes"
import { sanitizeMessage } from "#/components/messaging/utils"

export default function useCreateThread(): UseMutationResult<InAppMessagingThread, ResponseError, NewThread> {
  return useMutation<InAppMessagingThread, ResponseError, NewThread>(
    ({ subject, message, viaFollowUpSourceId }: NewThread) => {
      const sanitizedMessage = sanitizeMessage(message)
      return carrotClient.createThread(subject, sanitizedMessage, viaFollowUpSourceId)
    },
    {
      retry: (failureCount, error) => {
        switch (error.statusCode) {
          case HttpStatusCodes.UNAUTHORIZED:
          case HttpStatusCodes.BAD_REQUEST:
          case HttpStatusCodes.NOT_FOUND:
            return false
          default:
            return failureCount <= 3
        }
      }
    }
  )
}
